import { ThemeMode } from '../types/models';

const STORAGE_KEY = 'smsResaleUiTheme';

export function getSystemTheme(): ThemeMode {
  if (typeof window === 'undefined') {
    return 'light';
  }
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function getSavedTheme(): ThemeMode | null {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value === 'light' || value === 'dark' ? value : null;
  } catch {
    return null;
  }
}

export function applyTheme(theme: ThemeMode): void {
  document.documentElement.setAttribute('data-ui-theme', theme);
  document.documentElement.style.colorScheme = theme;
}

export function saveTheme(theme: ThemeMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    // ignore localStorage errors in restricted environments
  }
}

export function initTheme(): ThemeMode {
  const nextTheme = getSavedTheme() || getSystemTheme();
  applyTheme(nextTheme);
  return nextTheme;
}

export function toggleTheme(current: ThemeMode): ThemeMode {
  const nextTheme: ThemeMode = current === 'dark' ? 'light' : 'dark';
  applyTheme(nextTheme);
  saveTheme(nextTheme);
  return nextTheme;
}
